















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class BaseTextarea extends Vue {
  @Prop() resizeable: boolean;
  @Prop() invalid: boolean;
  @Prop() label: string;
  @Prop() value: string;
  @Prop() id: string;
  @Prop({ default: 4 }) rows: number;
  @Prop({ default: false }) required: boolean;

  showRequiredMessage() {
    return this.$refs['textarea'];
  }

  get inputId(): string {
    return this.id || this.$options['_scopeId'];
  }

  get listeners() {
    return {
      ...this.$listeners,
      input: event => this.$emit('input', event.target.value),
    };
  }
}
